import { combineTokens } from '@utils/css';

const boundaryTokens = combineTokens("--image-boundary", {
  maxWidth: "100%",
  aspectRatio: 0,
  captionHeight: "0px"
});
const boundaryCls = "gfxbiglics";
const aspectCls = "gfxaxgvi8l";
const contentCls = "gfxc10qybc8";

export { aspectCls, boundaryCls, boundaryTokens, contentCls };
import "./Boundary.linaria.module.css";
//# sourceMappingURL=Boundary.js.map
